export const API_URL = process.env.REACT_APP_API_URL as string
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL as string
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL as string
export const SITE_URL = `${process.env.REACT_APP_SITE_URL}/` as string
export const STOREFRONT_URL = `${process.env.REACT_APP_STOREFRONT_URL}/` as string
export const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID as string
export const APPLE_REDIRECT_URL = process.env.REACT_APP_SITE_URL as string
export const SUPPORT_URL = process.env.REACT_APP_SUPPORT_URL as string
export const INTEGRATION_API_URL = process.env.REACT_APP_INTEGRATION_API_URL as string
export const NOTIFICATIONS_BOT_URL = process.env.REACT_APP_NOTIFICATIONS_BOT_URL as string
export const TELEGRAM_NOTIFICATIONS_BOT_URL = 'https://t.me/HorseSmart_sellerbot'
